export default __webpack_public_path__ + "static/media/profile-header.a5055d9d.png";